import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Pipe({
    name: 'buscadorPersonal'
})

export class BuscadorPersonalPipe implements PipeTransform {

    /**
     * Se hace cargo de filtrar los resultados de una consulta de
     * acuerdo al tipo de buscador y el textp que se coloque en el input
     * @param busqueda
     * @param filtro
     */
    transform(busqueda:Array<any>, filtro:string):any{
        // Checa que la búsqueda regresará nulo
        if(!busqueda)
            return busqueda;
        else{
            // Checa si el filtro tiene algo escrito y si existen registros en la búsqueda
            if(filtro && filtro.trim().length > 0 && busqueda.length > 0){
                filtro = filtro.toLowerCase();
                let filtradoObjetos = [];
                // Realiza el filtrado de acuerdo al tipo de buscador que se seleccionó
                filtradoObjetos = busqueda.filter(personal => {
                    console.log(personal)
                    //prueba la busqueda en el no,bre y los apellidos
                    if(personal.informacionPersonal.nombre.toLowerCase().indexOf(filtro) != -1)
                        return personal.informacionPersonal.nombre.toLowerCase().indexOf(filtro) != -1
                    if(personal.informacionPersonal.apellidoMaterno.toLowerCase().indexOf(filtro) != -1)
                        return personal.informacionPersonal.apellidoMaterno.toLowerCase().indexOf(filtro) != -1
                    if(personal.informacionPersonal.apellidoPaterno.toLowerCase().indexOf(filtro) != -1)
                        return personal.informacionPersonal.apellidoPaterno.toLowerCase().indexOf(filtro) != -1
                    if(personal.informacionLaboral.email!=null)
                    {
                        if(personal.informacionLaboral.email.toLowerCase().indexOf(filtro) != -1)
                            return personal.informacionLaboral.email.toLowerCase().indexOf(filtro) != -1
                    }
                    if(filtro.trim().length == 3)
                    {
                        if(personal.informacionPersonal.nombre.toLowerCase()[0]==filtro[0] &&
                            personal.informacionPersonal.apellidoPaterno.toLowerCase()[0]==filtro[1] &&
                            personal.informacionPersonal.apellidoMaterno.toLowerCase()[0]==filtro[2])
                            return true
                    }

                });
                return filtradoObjetos;
            } else { // Si el filtro viene vacío, no hace ningún filtro
                return busqueda;
            }
        }
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/busquedor-personal.pipe.ts